import { render, staticRenderFns } from "./MessageNonConformanceReport.vue?vue&type=template&id=2f83c86f&"
import script from "./MessageNonConformanceReport.vue?vue&type=script&lang=js&"
export * from "./MessageNonConformanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports